import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

interface Props {
  current: 0 | 1 | 2;
}

const STEPS = ['Upload plan', 'Review differences & confirm details', 'Finalize import'];

/**
 * Lightweight 3-step indicator above the wizard body. Mirrors the bar shown in
 * the screenshots; we use plain divs rather than pulling in a new dependency.
 */
export const WizardStepper = ({ current }: Props) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" css={({ theme }) => ({ gap: theme.space[4] })} mb="8">
        {STEPS.map((_, i) => (
          <Box
            key={i}
            flexGrow={1}
            height={4}
            borderRadius="full"
            bg={i <= current ? 'primary.500' : 'neutral.200'}
          />
        ))}
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        css={({ theme }) => ({ gap: theme.space[16] })}
      >
        {STEPS.map((label, i) => (
          <Box key={label} flex={1}>
            <Text
              color={i === current ? 'neutral.700' : 'neutral.500'}
              fontWeight={i === current ? 600 : 400}
              fontSize="small"
            >
              {label}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
